import { render, staticRenderFns } from "./Home.appsflyer-link-generator.vue?vue&type=template&id=fa0f4d48&scoped=true&lang=html&"
import script from "./Home.appsflyer-link-generator.vue?vue&type=script&lang=js&"
export * from "./Home.appsflyer-link-generator.vue?vue&type=script&lang=js&"
import style0 from "./Home.appsflyer-link-generator.vue?vue&type=style&index=0&id=fa0f4d48&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa0f4d48",
  null
  
)

export default component.exports